import { DateRangeQueryParams } from '@sonar-software/sonar-ts-types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';

export enum ApiVolumeByApplicationGroupingType {
	Day = 'Day',
	Week = 'Week',
	Month = 'Month',
}

export type ApiVolumeByApplication = {
	applicationId: number;
	date: string;
	totalEvents: number;
};

export type getDataSecurityApiVolumeByApplicationRequest = DateRangeQueryParams & {
	calendarGroupingType: ApiVolumeByApplicationGroupingType;
};

export type getDataSecurityApiVolumeByApplicationResponse = Array<ApiVolumeByApplication>;

export const getDataSecurityApiVolumeByApplication = createGetEndpoint<
	getDataSecurityApiVolumeByApplicationRequest,
	getDataSecurityApiVolumeByApplicationResponse
>((request) => `/api/v3/data-security/organization/api-volume/by-application?${getQueryString(request)}`);
